import styled from "styled-components";

export const Container = styled.div`
  min-width: 992px;
  //position: relative;
  display: inline-block;
  width: 100%;
  height:100%;
`;
